import React, { useState } from "react";
import { TextField, Button, Container, Typography, Box, Alert } from "@mui/material";
import { sendPasswordResetEmail } from "../services/authAPI"; // Adjust the import path as necessary

function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      await sendPasswordResetEmail(email);
      setMessage("Password reset email sent successfully. Please check your inbox.");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box mt={8}>
      <Container maxWidth="sm">
        <Typography variant="h4" component="h1" gutterBottom>
          Forgot Password
        </Typography>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </form>
      </Container>
    </Box>
  );
}

export default ForgotPasswordForm;